<app-home-info-head></app-home-info-head>
<ng-container *ngIf="items != undefined">
    <app-home-info-item *ngFor="let item of items; let even = even" [item]="item" [imageFirst]="even"></app-home-info-item>
    <app-home-jewels></app-home-jewels>
</ng-container>
